import PermissionTemplate from "permissions/templates/permission-template";

export default class PermissionTemplateCommand {
  public readonly id?: string;
  public readonly userId?: string;
  public readonly resources?: string;
  public readonly name?: string;
  public readonly description?: string;
  public readonly createdDate?: string;
  public readonly deletedDate?: string;

  public constructor(template: PermissionTemplate) {
    this.id = template.id?.value;
    this.userId = template.userId?.value;
    this.resources = `[${template.resources?.map((resource) => JSON.stringify(resource.toJSON())).join(", ")}]`;
    this.name = template.name;
    this.description = template.description;
    this.createdDate = template.createdDate?.toISOString();
    this.deletedDate = template.deletedDate?.toISOString();
  }
}
